import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { MobileEmergencyBar } from "@/components/MobileEmergencyBar";
import { CookieBanner } from "@/components/CookieBanner";
import { useSmoothScroll } from "@/hooks/useSmoothScroll";

export function Layout({ children }) {
  useSmoothScroll();
  return (
    <div className="min-h-screen bg-carbon">
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[70] focus:rounded-md focus:bg-amber focus:px-4 focus:py-2 focus:font-bold focus:text-carbon">
        Vai al contenuto
      </a>
      <Header />
      <main id="main">{children}</main>
      <Footer />
      <MobileEmergencyBar />
      <CookieBanner />
    </div>
  );
}
